// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"6797":"3b53517f","9677":"3b53517f"}[chunkId] + ".chunk.css");